import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TALUKA_LIST, TALUKA_CHANGE_STATUS, TALUKA_ADDEDIT, TALUKA_WOP_LIST, TALUKA_DELETE } from "../../api/constApi";
import { TalukaListApi, TalukaChangeStatusApi, AddEditTalukaApi, TalukaWopListApi, talukaDeleteApi } from "../Services/talukaService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const talukaList = createAsyncThunk(TALUKA_LIST, async (payload) => {
    const response = await TalukaListApi(payload);
    return response.data;
});

export const talukaChangeStatus = createAsyncThunk(TALUKA_CHANGE_STATUS, async (payload) => {
    const response = await TalukaChangeStatusApi(payload);
    return response.data;
});

export const addEditTaluka = createAsyncThunk(TALUKA_ADDEDIT, async (payload) => {
    const response = await AddEditTalukaApi(payload);
    return response.data;
});

export const talukaWopList = createAsyncThunk(TALUKA_WOP_LIST, async (payload) => {
    const response = await TalukaWopListApi(payload);
    return response.data;
});

export const deleteTaluka = createAsyncThunk(TALUKA_DELETE, async (payload) => {
    const response = await talukaDeleteApi(payload);
    return response.data;
});

export const talukaSlice = createSlice({
    name: "taluka",
    initialState: {
        taluka: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(talukaList.fulfilled, (state, action) => {
            state.taluka = action?.payload;
        });
        builder.addCase(addEditTaluka.fulfilled, (state, action) => {
            state.taluka = action?.payload?.Data;
          });
    }
}); 

export default talukaSlice.reducer;

// villagelist selector
export const selectTalukaList = (state) => state?.taluka?.taluka;
export const useTalukaList = () => {
  const taluka = useSelector(selectTalukaList);
  return useMemo(() => taluka, [taluka]);
};
